<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Typography</h1>
			</div>
		</div>
		<!--Content-->
    <div id="content">
      <h2>Typefaces</h2>
      <h3>Basic</h3>
      <div class="right">
        <img :src="notoSans" alt="">
      </div>
      <h3>Chrome OS <br />Android</h3>
      <div class="right">
        <img :src="roboto" alt="">
      </div>

      <h3>windows</h3>
      <div class="right">
        <img :src="segoe" alt="">
      </div>

      <h3>Apple mac OS<br />Apple iOS</h3>
      <div class="right">
        <img :src="sanFrancisco" alt="">
      </div>

      <h3>Linux</h3>
      <div class="right">
        <img :src="ubuntu" alt="">
      </div>

      <div class="mt--clearfix"></div>

      <h2>Scale</h2>
      <h3 class="mt-font--title30">Title 30</h3>
      <div class="right">35px</div>

      <h3 class="mt-font--title20">Title 20</h3>
      <div class="right">28px</div>

      <h3 class="mt-font--title10">Title 10</h3>
      <div class="right">18px</div>

      <h3 class="mt-font--body20">Body 20</h3>
      <div class="right">16px</div>

      <h3 class="mt-font--body10">Body 10</h3>
      <div class="right">14px</div>

      <h3 class="mt-font--caption20">Caption 20</h3>
      <div class="right">12px</div>

      <h3 class="mt-font--caption10">Caption 10</h3>
      <div class="right">11px</div>

      <div class="mt--clearfix"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'typography',
  props: [],
  components: {

  },
  data () {
    return {
      notoSans: require('@/assets/noto-sans.png'),
      roboto: require('@/assets/roboto.png'),
      sanFrancisco: require('@/assets/san-francisco.png'),
      segoe: require('@/assets/segoe-ui.png'),
      ubuntu: require('@/assets/ubuntu.png'),
    }
  },
  computed: {

  },

  methods: {

  },


}
</script>
<style lang="scss" scoped>
@import "../plugins/mtui/styles/Variables.scss";
.right {
  width: 45%;
  float: right;
  padding-bottom: 20px;
  img { width: 512px; }
}

.right img + img {
  border-top: 1px solid $c-neutrals-light-gray-02;
}
</style>



// WEBPACK FOOTER //
// Typography.vue?9b93d56a